module.exports = __webpack_public_path__ + "static/img/nav5.c5c00ca9.svg";